import { isNonEmptyArray, isObject, validateString } from '..'
import { Properties } from '../entities'

export const InstitutionGroupProperties = Object.freeze({
  ACRONYM: [Properties.ACRONYM],
  ADDRESS: [Properties.ADDRESS],
  CITY: [Properties.CITY],
  COUNTRY: [Properties.COUNTRY],
  NAME: [Properties.NAME],
  ZIPCODE: [Properties.ZIPCODE],
  INSTITUTIONS: [Properties.INSTITUTIONS]
})

export const INSTITUTION_GROUP_VALIDATORS = [
  { key: Properties.ACRONYM, validator: ig => validateString(ig.acronym, { notEmpty: true }) },
  { key: Properties.COUNTRY, validator: ig => isObject(ig.country) },
  { key: Properties.NAME, validator: ig => validateString(ig.name, { notEmpty: true }) }
]

export class InstitutionGroup {
  constructor({ id, acronym, address, city, country, name, zipcode, institutions } = {}) {
    this.id = id ?? '-1'
    this.acronym = acronym ?? ''
    this.address = address ?? ''
    this.city = city ?? ''
    this.country = country ?? null
    this.name = name ?? ''
    this.zipcode = zipcode ?? ''
    this.institutions = isNonEmptyArray(institutions) ? institutions : []
  }

  toRequestBody = () => {
    return {
      id: this.id,
      acronym: this.acronym,
      address: this.address,
      city: this.city,
      country: this.country === null ? null : this.country.code,
      name: this.name,
      zipcode: this.zipcode
    }
  }
}
